<template>
  <div class="list" style="max-height: 340px;
  overflow-y: auto;">
 
    <template v-if="ranks.length > 0">
      <div v-for="(witem, indexw) in ranks"> 
        <div style=" display: flex;
        flex-wrap: wrap;    border: 1px solid #ccc;
        padding: 20px;
       margin-bottom:20px"> 
        <div style="width:150px;text-align:center;padding-top: 30px;
        font-size: 20px;"> {{ witem.name }} </div>
        <div style="flex: 1;"> <template v-for="(item, index) in witem.children">
          <div class="item" :key="index" @click.stop.prevent="jfNotice($event, {name: currentQueryType == 'import'?'queryRateI':'queryRateE', 
          params: {exporter: item.exporter.id, importer: importerID, hscode: hscode},
           query: {
                _t: new Date().getTime(),
                text: item.exporter.name
              }
              })">
            <div class="item-wrap">
              <img :src="item.exporter.icon" />
              <div class="info">
                <div class="name"><Tooltip :content="item.exporter.name" transfer>{{item.exporter.name}}</Tooltip></div>
                <div class="value">
                  <RateView :content="$options.filters.rateValueAccording(item.tax, item.description)" :strLen="8"></RateView>
                </div>
              </div>
           
            </div>
          </div>
        </template> </div>
        
       </div>
      
    
    </div>
   
    </template>
    <div class="nodata" v-else>暂无数据</div>
  </div>
</template>

<script>
import RateView from '@/components/query/common/RateView'

export default {
  name: 'OtherFtaList',
  components: { RateView },
  props: {
    currentQueryType: String,
    ranks: {
      type: Array,
      default: () => [],
      required: false
    },
    exporterID: {
      type: [String, Number]
    },
    importerID: {
      type: [String, Number]
    },
    hscode: {
      type: [String, Number]
    }
  },
  mounted () {
    this.$nextTick(() => {
      setTimeout(() => { this.refresh() }, 500)
    })
  },
  methods: {
    jfNotice (event, params) {
      this.$router.push(params)
    },
    refresh () {
      this.$refs.iscroll && this.$refs.iscroll.refresh()
    }
  }
}
</script>

<style scoped>
.list{
 

}
.item{
  width: 16%;
  text-align: center;
  display: inline-block;
}
.item-wrap{
  margin: 5px 10px 5px;
}
.item img{
  max-width: 50px;
  margin: 0 auto 6px;
  width: 100%;
}
.item .info{
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  color: #666;
  font-size: 15px;
}
.item .name >>> .ivu-tooltip{
  display: block;
}
.item .name, .item .name >>> .ivu-tooltip-rel{
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
}
.nodata{
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%， -50%);
  font-style: normal;
  font-size: 14px;
  margin-left: -40px;
}
</style>


// WEBPACK FOOTER //
// src/components/query/zh-CN/OtherFta.vue